module.exports = __webpack_public_path__ + "assets/img/wx-1.c9bb57ed.png";